import { SCREENS, PANELS, FALLBACK } from './loading-phrases';

const ROTATE_EVERY_MS = 4500;
const SWAP_MS = 220;

const MARK = `
    <svg class="app-loader-mark" viewBox="0 0 46 104" aria-hidden="true" focusable="false">
        <polygon class="app-loader-pillar app-loader-pillar-1" points="15.6,7.4 0,9 0,92.7 15.6,93.8" />
        <path class="app-loader-pillar app-loader-pillar-2" d="M21.2,16.3l8.6,0.2v75.3l5.3-0.5v10.9l-13.9,0.6V16.3z M36.2,15.9L36.2,15.9 l0-0.3l-16.1-0.4V104l16.1-0.7v-12l0,0V15.9z" />
        <polygon class="app-loader-pillar app-loader-pillar-3" points="45.9,1.5 29.8,0 29.8,15.6 36.2,15.9 36.2,91.3 45.9,90.4" />
    </svg>`;

class MainBusyIndicator {
    constructor($state, $interval, $timeout) {
        this.$state = $state;
        this.$interval = $interval;
        this.$timeout = $timeout;

        this.restrict = 'C';
        this.link = this.MainBusyIndicatorLink.bind(this);
    }

    MainBusyIndicatorLink(scope, element, attrs) {
        const host = element[0];
        const loader = angular.element(`
            <div class="app-loader">
                ${MARK}
                <div class="app-loader-progress" aria-hidden="true"><span></span></div>
                <p class="app-loader-message" aria-hidden="true"></p>
                <span class="sr-only" role="status">Loading</span>
            </div>`);
        element.append(loader);

        // Either on the loader or on an element around it (the rentals dialogs keep them off
        // the loader's own lines)
        const phrasesHolder = this._closestWith(host, 'data-loading-phrases');
        const loadingPhrases = phrasesHolder && phrasesHolder.getAttribute('data-loading-phrases');

        // A page with its own spinner (City Living rentals) keeps it on mobile too
        const spinnerHolder = this._closestWith(host, 'data-custom-spinner');
        if (spinnerHolder) {
            scope.$watch(
                () => spinnerHolder.getAttribute('data-custom-spinner'),
                (spinner) => element.toggleClass('has-custom-spinner', !!spinner)
            );
        }

        const messageEl = loader[0].querySelector('.app-loader-message');
        if (loadingPhrases === 'none') {
            messageEl.remove();
            return;
        }
        const messages = this._shuffled(this._messagesFor(loadingPhrases, this.$state.current.name || ''));
        let index = 0;
        messageEl.textContent = messages[index];

        let measuredAt = 0;
        const holdHeight = () => {
            const width = host.clientWidth;
            if (host.offsetParent === null || !width || width === measuredAt) {
                return;
            }
            measuredAt = width;
            messageEl.style.minHeight = '';
            let tallest = 0;
            messages.forEach((text) => {
                messageEl.textContent = text;
                tallest = Math.max(tallest, messageEl.offsetHeight);
            });
            messageEl.textContent = messages[index];
            messageEl.style.minHeight = `${tallest}px`;
        };
        this.$timeout(holdHeight, 0, false);

        const tick = this.$interval(() => {
            if (host.offsetParent === null) {
                return;
            }
            holdHeight();
            messageEl.classList.add('is-leaving');
            this.$timeout(() => {
                index = (index + 1) % messages.length;
                messageEl.textContent = messages[index];
                messageEl.classList.remove('is-leaving');
            }, SWAP_MS, false);
        }, ROTATE_EVERY_MS, 0, false);

        scope.$on('$destroy', () => this.$interval.cancel(tick));
    }

    // The element itself or its nearest ancestor with the attribute (no Element.closest in IE)
    _closestWith(element, attribute) {
        for (let el = element; el && el.nodeType === 1; el = el.parentNode) {
            if (el.hasAttribute(attribute)) {
                return el;
            }
        }
        return null;
    }

    _shuffled(list) {
        const copy = list.slice();
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const swap = copy[i];
            copy[i] = copy[j];
            copy[j] = swap;
        }
        return copy;
    }

    _messagesFor(panel, stateName) {
        if (panel) {
            if (PANELS[panel]) {
                return PANELS[panel];
            }
            console.warn(`No loading phrases called '${panel}' in loading-phrases.js`);
        }
        return SCREENS[stateName] || SCREENS[stateName.split('.')[0]] || FALLBACK;
    }
}

export default /* @ngInject */ ($state, $interval, $timeout) => new MainBusyIndicator($state, $interval, $timeout);
